const ONE_OFF_AND_ANNUAL_DONATION_PRESETS = ["500", "1000", "2000"];
const RECURRING_DONATION_PRESETS = ["100", "150", "250"];

export const DEFAULT_DONATION_FREQUENCY = "Monthly";

export const getDonationPresets = (frequency) =>
  ["One-time Gift", "Annually"].includes(frequency)
    ? ONE_OFF_AND_ANNUAL_DONATION_PRESETS
    : RECURRING_DONATION_PRESETS;
